import script from "./OAvatarProfissional.vue?vue&type=script&lang=ts&setup=true"
export * from "./OAvatarProfissional.vue?vue&type=script&lang=ts&setup=true"

import "./OAvatarProfissional.vue?vue&type=style&index=0&id=260dfd78&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260dfd78"]])

export default __exports__